module.exports = __webpack_public_path__ + "static/media/hicks-ngv.31d9f10a.jpg";